import * as notifier from './notifier.js';
import * as loader from './loader.js';
import * as spendingAccounts from '../xhr/spendingAccounts.js';
import * as types from './types/spendingAccounts.js';
import { loadUserData } from './user.js';
import { i18n, tokens } from '@simplybenefits/sb-ui-library';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'full') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 *
 * @param {*} claimID
 */
export function HSApayment(claimID) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return spendingAccounts
            .HSApayment(claimID)
            .then((data) => {
                dispatch({
                    type: types.ADD_HEALTH_USAGE,
                    data
                });

                setLoader(dispatch, false);
                return Number(data.amountUsed) || 0;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param hsaMax
 * @param lsaMax
 * @returns {function(*=): Promise<boolean>}
 */
export function setSpendingAccountMaximums(hsaMax, lsaMax) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return spendingAccounts
            .setSpendingAccountMaximums(hsaMax, lsaMax)
            .then(async () => {
                await dispatch(loadUserData());

                setLoader(dispatch, false);
                dispatch(notifier.displayMessage(i18n.t(tokens.labels.notifications.spendingAccountMaximumsSetSuccessfully)));
                return null;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @returns {function(*): Promise<* | boolean>}
 */
export function getLsaItems() {
    return (dispatch) => {
        setLoader(dispatch, true);

        return spendingAccounts
            .getLsaItems()
            .then((data) => {
                setLoader(dispatch, false);
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 *
 * @param {*} filters
 * @param {*} sort
 * @returns
 */
export function getHSAClaims(filters = {}, sort = false) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return spendingAccounts
            .getHSAClaims(filters, sort)
            .then((claimsData) => {
                setLoader(dispatch, false);

                dispatch({
                    type: types.GET_HSA_CLAIMS_SUCCESS,
                    claims: claimsData
                });
            })
            .catch((error) => {
                setLoader(dispatch, false);
                notifier.displayError(error.verbiage);
            });
    };
}

/**
 *
 * @param {*} filters
 * @param {*} sort
 * @returns
 */
export function getLSAClaims(filters = {}, sort = false) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return spendingAccounts
            .getLSAClaims(filters, sort)
            .then((claimsData) => {
                setLoader(dispatch, false);

                dispatch({
                    type: types.GET_LSA_CLAIMS_SUCCESS,
                    claims: claimsData
                });
            })
            .catch((error) => {
                setLoader(dispatch, false);
                notifier.displayError(error.verbiage);
            });
    };
}